import Api from './Api'

export default {
  index () {
    return Api().get('/acl/roles.json')
  },

  dropdown () {
    return Api().get('/acl/roles/dropdown.json')
  }
}



// WEBPACK FOOTER //
// ./src/services/AclService.js